<template>
  <div class="level-progress-container">
    <div class="progress-header">
      <!-- Level text on the left -->
      <div class="level-text">LVL {{ levelData.currentLevel.level }}</div>
      
      <!-- Taps counter and progress on the right -->
      <div class="taps-counter">
        {{ formatNumber(levelData.currentTaps) }} / {{ formatNumber(levelData.tapsNeeded) }}
      </div>
    </div>
    
    <!-- Progress bar -->
    <div class="level-progress-bar">
      <div 
        class="progress-fill" 
        :style="{ width: levelData.progress + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'LevelProgressBar',
  props: {
    currentCoins: {
      type: Number,
      required: true
    },
    levelTable: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const levelData = computed(() => {
      // Find current level
      let currentLevelObj = null;
      let prevLevelObj = null;
      
      for (let i = (props.levelTable && props.levelTable.length) ? props.levelTable.length - 1 : -1; i >= 0; i--) {
        if (props.levelTable && props.levelTable[i] && props.currentCoins >= props.levelTable[i].tapsRequired) {
          currentLevelObj = props.levelTable[i];
          break;
        }
      }
      
      // Find previous level
      for (let i = (props.levelTable && props.levelTable.length) ? props.levelTable.length - 1 : -1; i >= 0; i--) {
        if (props.levelTable && props.levelTable[i] && props.currentCoins > props.levelTable[i].tapsRequired) {
          prevLevelObj = props.levelTable[i];
          break;
        }
      }
      
      if (!currentLevelObj) {
        return {
          currentLevel: { level: 1, name: 'Wooden Coin' },
          currentTaps: props.currentCoins,
          tapsNeeded: 5000,
          progress: Math.min(100, (props.currentCoins / 5000) * 100)
        };
      }
      
      const nextLevelIndex = props.levelTable ? props.levelTable.findIndex(l => l.level === currentLevelObj.level + 1) : -1;
      const nextLevelObj = (props.levelTable && nextLevelIndex !== -1 && props.levelTable[nextLevelIndex]) ? props.levelTable[nextLevelIndex] : null;
      
      let progress = 0;
      let tapsNeeded = 0;
      
      if (prevLevelObj && nextLevelObj) {
        const range = nextLevelObj.tapsRequired - prevLevelObj.tapsRequired;
        const progressInRange = props.currentCoins - prevLevelObj.tapsRequired;
        progress = Math.min(100, (progressInRange / range) * 100);
        tapsNeeded = nextLevelObj.tapsRequired;
      } else if (!prevLevelObj && nextLevelObj) {
        // First level
        progress = Math.min(100, (props.currentCoins / nextLevelObj.tapsRequired) * 100);
        tapsNeeded = nextLevelObj.tapsRequired;
      } else {
        // Max level
        progress = 100;
        tapsNeeded = currentLevelObj.tapsRequired;
      }
      
      return {
        currentLevel: currentLevelObj,
        currentTaps: props.currentCoins,
        tapsNeeded: tapsNeeded,
        progress: progress
      };
    });

    const formatNumber = (num) => {
      // Format as whole number without decimals
      return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    return {
      levelData,
      formatNumber
    };
  }
};
</script>

<style scoped>
.level-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 77px 0 15px 0; /* Поднял на 20px вверх (97px - 20px = 77px) */
  width: 100%;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 300px; /* Увеличил ширину шкалы */
}

.level-text {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #e0e0e0;
  text-align: left;
  margin: 0;
  flex-shrink: 0;
}

.taps-counter {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #a0a0a0;
  text-align: right; /* Передвинул вправо */
  margin: 0;
  flex-shrink: 0;
}

.level-progress-bar {
  width: 300px; /* Увеличил ширину шкалы (с 276px до 300px) */
  height: 5px;
  background: #2a2a2a;
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4d8cff 0%, #00d2ff 100%);
  border-radius: 999px;
  transition: width 0.3s ease;
  box-shadow: 0 0 8px rgba(77, 140, 255, 0.3);
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .level-progress-bar {
    width: 277px; /* Увеличил ширину шкалы (с 253px до 277px) */
  }
  
  .level-text {
    font-size: 14px;
  }
  
  .taps-counter {
    font-size: 12px;
  }
}

@media (max-width: 320px) {
  .level-progress-bar {
    width: 254px; /* Увеличил ширину шкалы (с 230px до 254px) */
  }
  
  .level-text {
    font-size: 13px;
  }
  
  .taps-counter {
    font-size: 11px;
  }
}
</style>